export default {
    namespaced: true,
    state: {
        classNames: undefined,
        pageIds: undefined
    },
    mutations: {
        classNames(state, classNames) {
            state.classNames = classNames
        },
        pageIds(state, pageIds) {
            state.pageIds = pageIds
        }
    },
    actions: {
        async init({state, dispatch, commit}) {
            if (state.pageIds === undefined) {
                commit('pageIds', [])
                
                const pageIds = (await dispatch('request/get', {
                    url: 'api/component/pages/id'
                }, {root: true})).data.values
                
                commit('pageIds', pageIds)
                
                await dispatch('itemData/preload', {tableName: 'pages', ids: pageIds}, {root: true})
            }
            
            return state.pageIds
        },
        async classNames({state, commit, dispatch}, {refresh}) {
            if (state.classNames === undefined || refresh) {
                commit('classNames', [])
                
                const classNames = (await dispatch('request/get', {
                    url: 'api/component/pages/class',
                    params: {groupBy: 'class', sort: 'class'}
                }, {root: true})).data.values.filter(Boolean)
                
                commit('classNames', classNames)
            }
            
            return state.classNames
        }
    }
}